import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {
    Content_GetPrerequisiteExercises as QueryResponse,
    Content_GetPrerequisiteExercisesVariables as QueryVariables,
} from "./__graphql-types__/Content_GetPrerequisiteExercises.ts";

export const CONTENT_GET_PREREQUISITE_EXERCISES: GqlOperation<
    QueryResponse,
    QueryVariables
> = gqlOp(gql`
    query Content_GetPrerequisiteExercises($slugs: [String!]!) {
        exercisesBySlugs(slugs: $slugs) {
            id
            slug
            translatedTitle
            translatedDescription
            mappedStandards {
                id
                standardId
            }
        }
    }
`);
